module.exports = __webpack_public_path__ + "static/media/caja.3f3f6578.svg";